import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/**
 * DraggableNode - A sortable node container for waypoint groups
 * 
 * Used in WaypointListSection to allow reordering of node groups
 * (WeldNode, AirMoveNode, etc.) via drag and drop.
 */
export default function DraggableNode({ 
  node, 
  nodeIndex, 
  expandedNodes, 
  toggleNode, 
  children 
}) {
  const stableId = node._stableId || `node-${node.feature}-${node.type}`;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: stableId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="border border-border rounded">
      <div
        className="flex items-center gap-2 p-2 cursor-pointer hover:bg-bg-hover transition-colors"
        onClick={() => toggleNode(nodeIndex)}
      >
        <span
          {...attributes}
          {...listeners}
          className="cursor-grab active:cursor-grabbing px-1 hover:bg-bg-tertiary rounded"
          onClick={(e) => e.stopPropagation()}
        >
          ⋮⋮
        </span>
        <span className={`transform transition-transform ${expandedNodes.has(nodeIndex) ? 'rotate-90' : ''}`}>
          ▶
        </span>
        <span className="text-text-primary">{node.type} - {node.feature}</span>
        <span className="text-text-secondary text-sm">({node.indices.length})</span>
      </div>
      {expandedNodes.has(nodeIndex) && children}
    </div>
  );
}
